import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { jwtDecode } from "jwt-decode";
import ImagineHomeService from "./imagineHomeService";
import { InputText } from "primereact/inputtext";
import CardPointeService from "../../service/cardPointeService";
import { Dialog } from "primereact/dialog";
import NotFound from "../NotFound";
import CardPointeTokenizerIframe from "../../components/iframe/CardPointeTokenizerIframe.js";
import { commonMailSender } from "./customer.js";
import { Dropdown } from "primereact/dropdown";

function useQuery() {
    // http://localhost:3000/checkout?proposal=10&amount=1000&token=eyJraWQiOiJVUUFJbXR3Mzg0YXNNYXlRY3ZwQzdWcUtKenl0ZkZKVmFrZ2VcLzMzcExibz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIzMTIzZmRmYS1mMDExLTcwOTgtZWFlYS00ZjgxYzVlZjRiYjAiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2YxcFNZTlRDaSIsImNsaWVudF9pZCI6IjJndGxlYWdiMzFwdnIyZzQ1c2UxM2E5NG8yIiwib3JpZ2luX2p0aSI6IjhhZTc5Y2VlLTJiOTUtNGI2YS05ZGYzLTdjOTMyZDEzMDFkNSIsImV2ZW50X2lkIjoiYzhiMTE4MjEtMDBhYS00N2QxLWFjMTEtYTE2YWQwNjBhNDU0IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc1ODI4NDUxMSwiZXhwIjoxNzU4Mjg4MTExLCJpYXQiOjE3NTgyODQ1MTEsImp0aSI6ImYzNjEyNTQ5LWNkNTQtNDg1My1hMmMyLWM4OWI2MjFmNjU4YSIsInVzZXJuYW1lIjoiNDRlOGY0YzgtNjBlMS03MDhhLWY2ZWQtN2U3MjRlNzcyMjlhIn0.fh4SwbDVEE6ogg5xeS7HE-rDiCg8AjCSigdczzyY9g5J52sG8M5vqduthIHdiciojj6spH5iElvWjk3LCtCam3UyOiLf8Ww3qMScKoDuXOLpIJCiIjYnNq6PzfXKEc9UBHHLa0AmgEVCUFCZ-_qwnTWHfq1BUnec21mfCA1tc6QuMOpxYPb9W2d9_qUuCNp6RQG8AbtVxegBwTHNF_mCDczDzi3YA9fWoSDEBna1tiIxa3MrpYfZUisIV1_3t8PqzrCT05MPmkCcdk3du6pXYOfD0JJ2v7y6l4KBLGvs6u1kfeqK9Y30P7fUBiEYmyFCcSR7kH2Lq4pXSreIwMYEdQ
    // with surcharge - http://localhost:3000/checkout?proposal=8&amount=7219&token=eyJraWQiOiJVUUFJbXR3Mzg0YXNNYXlRY3ZwQzdWcUtKenl0ZkZKVmFrZ2VcLzMzcExibz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJlMWIzNmRlYS0xMGYxLTcwNDctNGExNy1hMTZiZjViOTc0OGUiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2YxcFNZTlRDaSIsImNsaWVudF9pZCI6IjJndGxlYWdiMzFwdnIyZzQ1c2UxM2E5NG8yIiwib3JpZ2luX2p0aSI6IjFiYTcyMTI3LTJlMjMtNDEwYy04NmMyLThmN2M1OWI4ODVkNiIsImV2ZW50X2lkIjoiYjFlMmY2YWUtNGUwNi00NDY2LThiODQtZjc1M2YxZWYzYzU5IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc2MzU1MTExNSwiZXhwIjoxNzYzNTU0NzE1LCJpYXQiOjE3NjM1NTExMTUsImp0aSI6IjU1ZmFlYzE4LTlmYTgtNGI3Ny04NzhiLWU5YjAyYTgwNzJiYSIsInVzZXJuYW1lIjoiMTAwMDAwMDAwMDA3NiJ9.VqJRWiAZccnYk-iNG3Ry_amKbKu2JT8_amFO-9zdMSBLS-lOjx1YCe_Mi9Czovy7i_VF8qry9HW0aotdtALOOXy-qLks3midJS7UjoFJWhAGb6xgeW-zSeHXrNXT-TQY5OZo2-UiWxcTnTcXlctXtSDuNtbPyXPpxomsY2pC2BL-Lm2JIYGv2A0Z3Di8YHd00NVqAtqUNXnAvw7uiB8fSu1vgySmPyGzNPMXSsqtEMyh89ZOOZ53GG5kTRoRxuKWsPslHhM8sSLCaocr9HmZD4FqcdnO2Bm_SO9QsMSB6Rp-xP59EJGOnUbDS2f8Su248zBTWWU3XWBo6zIrrW3lug
    // without surcharge - http://localhost:3000/checkout?proposal=10&amount=1000&token=eyJraWQiOiJVUUFJbXR3Mzg0YXNNYXlRY3ZwQzdWcUtKenl0ZkZKVmFrZ2VcLzMzcExibz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIzMTIzZmRmYS1mMDExLTcwOTgtZWFlYS00ZjgxYzVlZjRiYjAiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2YxcFNZTlRDaSIsImNsaWVudF9pZCI6IjJndGxlYWdiMzFwdnIyZzQ1c2UxM2E5NG8yIiwib3JpZ2luX2p0aSI6ImRlNGNkMjMzLTg1NDYtNDRiZi1iYjJjLWU3MGQ1MWEwMTBmZiIsImV2ZW50X2lkIjoiMTgxMjYyZTktNzQzZS00ZGEzLWE4NjQtM2RiODIyYzdmNjNiIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc2ODIwMzg1OSwiZXhwIjoxNzY4MjA3NDU5LCJpYXQiOjE3NjgyMDM4NTksImp0aSI6ImMyZWM1ZjhmLTE5NDktNGM1Mi05ZWE0LWExN2JkNDJmMjZhYSIsInVzZXJuYW1lIjoiNDRlOGY0YzgtNjBlMS03MDhhLWY2ZWQtN2U3MjRlNzcyMjlhIn0.omM5_nbxpXd7atOsR8N1s9XikvlGFI1wnKkwKlX03mDU7u5UzMhlS2NpYgWknL5h8ayipRAIx44v4qv81EAhp6vlrC_NN-jGoiFgqwxXEpkvsbFxMeXjY63TdoigBedYFxelC9xzAytzg3oGIFAhPfck1mOOg2WLNwf7O3MkQMqLYXRP2ASG796MTlkQ3HvvT2UkmDIF9b3XRoayrTgXQ09W2s5erTvnobbWi6laTfAyuSqePleKruaOahU-flI9RvGtL6fjLdVD4fxJCUwDko9ghP5WZBlkOBKVIcd_fJsfCHnA9IHPJNYJl2dCsP65BAlYT5PAhJ-4YT2MzxMXeA
    // https://app.imagine-home.com/checkout?proposal=14144784012&amount=50.0&token=eyJraWQiOiJuNjBXMWZWbTAyN2lobWxqdTZmSTg0ZTl6Nk90NnpNVHdmbVgxcGhXbEZNPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI0NGE4MjQ1OC05MGExLTcwYWEtODY4Yy1iM2RkOTQwOWY3NzAiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV9PSGdlR2tzRXYiLCJjbGllbnRfaWQiOiI0NDE5ZG52aW92dGNwdXJzNWg4dW8zaTM5NCIsIm9yaWdpbl9qdGkiOiIxOWIzYmYzMC02ZWQ4LTRhYTQtODdiYy0yY2I1NzA4NzZlNGIiLCJldmVudF9pZCI6IjU5NTZiYTFjLTA0YWItNDkxYS1iNWI5LTNjODQ1NGNjYjFlZCIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE3NjI4NTI1NTUsImV4cCI6MTc2Mjg1NjE1NSwiaWF0IjoxNzYyODUyNTU1LCJqdGkiOiI3YzZiMWE5NS0zMDU0LTQxN2YtYTI3OC0yMjIwODBiODYyZGMiLCJ1c2VybmFtZSI6Ijk0MTg2NGM4LTgwNTEtNzAzMi1hNzc3LTQxZWFiYzlmMGYzYSJ9.vi-CxbRiSs2e2BEQ19u7W8Orf2Dd9J7Mbx84XaTomgyQrAR981OElq5BnM4lY-bFT-tNE2CXNY9oGVOKa6EF59YZyy5hOY-fVDJF3_HXa2LeBtjEUOgltOX1PzzAymu-DYW7U0gskronumC7GqqnNgzvWKQCfbbquTARoKfNe3YccLcy8a7asYJfYP1iX4F7387H8w1mk-bUPpEuxxsSnatfiHmkbDca4BKD-LifT8ihA_3e-a0F7inTxG-WVAtyePXV7001Nho1Ozujf-PXZm2cqAg0LYNlnSIgtDPi3sYQQmbqPdXxo3d4coT4msgSTC2IAXhmBKKqOdDLqMBW6w

    // without proposal without surcharge, enter actual card details - http://localhost:3000/checkout?&amount=1&customerId=kiran.mane%2B8@nextqore.com&token=eyJraWQiOiJVUUFJbXR3Mzg0YXNNYXlRY3ZwQzdWcUtKenl0ZkZKVmFrZ2VcLzMzcExibz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIzMTIzZmRmYS1mMDExLTcwOTgtZWFlYS00ZjgxYzVlZjRiYjAiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2YxcFNZTlRDaSIsImNsaWVudF9pZCI6IjJndGxlYWdiMzFwdnIyZzQ1c2UxM2E5NG8yIiwib3JpZ2luX2p0aSI6ImRlNGNkMjMzLTg1NDYtNDRiZi1iYjJjLWU3MGQ1MWEwMTBmZiIsImV2ZW50X2lkIjoiMTgxMjYyZTktNzQzZS00ZGEzLWE4NjQtM2RiODIyYzdmNjNiIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc2ODIwMzg1OSwiZXhwIjoxNzY4MjA3NDU5LCJpYXQiOjE3NjgyMDM4NTksImp0aSI6ImMyZWM1ZjhmLTE5NDktNGM1Mi05ZWE0LWExN2JkNDJmMjZhYSIsInVzZXJuYW1lIjoiNDRlOGY0YzgtNjBlMS03MDhhLWY2ZWQtN2U3MjRlNzcyMjlhIn0.omM5_nbxpXd7atOsR8N1s9XikvlGFI1wnKkwKlX03mDU7u5UzMhlS2NpYgWknL5h8ayipRAIx44v4qv81EAhp6vlrC_NN-jGoiFgqwxXEpkvsbFxMeXjY63TdoigBedYFxelC9xzAytzg3oGIFAhPfck1mOOg2WLNwf7O3MkQMqLYXRP2ASG796MTlkQ3HvvT2UkmDIF9b3XRoayrTgXQ09W2s5erTvnobbWi6laTfAyuSqePleKruaOahU-flI9RvGtL6fjLdVD4fxJCUwDko9ghP5WZBlkOBKVIcd_fJsfCHnA9IHPJNYJl2dCsP65BAlYT5PAhJ-4YT2MzxMXeA
    // with proposal without surcharge, enter actual card details - http://localhost:3000/checkout?&proposal=8&amount=1&customerId=kiran.mane%2B8@nextqore.com&token=eyJraWQiOiJVUUFJbXR3Mzg0YXNNYXlRY3ZwQzdWcUtKenl0ZkZKVmFrZ2VcLzMzcExibz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIzMTIzZmRmYS1mMDExLTcwOTgtZWFlYS00ZjgxYzVlZjRiYjAiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2YxcFNZTlRDaSIsImNsaWVudF9pZCI6IjJndGxlYWdiMzFwdnIyZzQ1c2UxM2E5NG8yIiwib3JpZ2luX2p0aSI6ImRlNGNkMjMzLTg1NDYtNDRiZi1iYjJjLWU3MGQ1MWEwMTBmZiIsImV2ZW50X2lkIjoiMTgxMjYyZTktNzQzZS00ZGEzLWE4NjQtM2RiODIyYzdmNjNiIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc2ODIwMzg1OSwiZXhwIjoxNzY4MjA3NDU5LCJpYXQiOjE3NjgyMDM4NTksImp0aSI6ImMyZWM1ZjhmLTE5NDktNGM1Mi05ZWE0LWExN2JkNDJmMjZhYSIsInVzZXJuYW1lIjoiNDRlOGY0YzgtNjBlMS03MDhhLWY2ZWQtN2U3MjRlNzcyMjlhIn0.omM5_nbxpXd7atOsR8N1s9XikvlGFI1wnKkwKlX03mDU7u5UzMhlS2NpYgWknL5h8ayipRAIx44v4qv81EAhp6vlrC_NN-jGoiFgqwxXEpkvsbFxMeXjY63TdoigBedYFxelC9xzAytzg3oGIFAhPfck1mOOg2WLNwf7O3MkQMqLYXRP2ASG796MTlkQ3HvvT2UkmDIF9b3XRoayrTgXQ09W2s5erTvnobbWi6laTfAyuSqePleKruaOahU-flI9RvGtL6fjLdVD4fxJCUwDko9ghP5WZBlkOBKVIcd_fJsfCHnA9IHPJNYJl2dCsP65BAlYT5PAhJ-4YT2MzxMXeA

    // ACH dev details
    // {
    //     "merchid": "835050000002",
    //     "account": "123456789",
    //     "bankaba": "031000503",
    //     "accttype": "ECHK",
    //     "amount": "1.00",
    //     "name": "Test",
    //     "ecomind": "T"
    // }

    return new URLSearchParams(useLocation().search);
}
export default function CheckoutPage() {
    const query = useQuery();
    const authToken = query.get("token");
    const customerId = query.get("customerId");
    const designerId = query.get("designerId");
    const amount = query.get("amount");
    const proposalId = query.get("proposal");
    const planId = query.get("planId");
    const isExit = query.get("exit");

    const [customer, setCustomer] = useState(null);
    const [serviceId, setServiceId] = useState(null);
    const [designer, setDesigner] = useState(null);
    const [tradePartner, setTradePartner] = useState(null);
    const [cardPointeUrl, setCardPointeUrl] = useState(null);
    const [gatewayToken, setGatewayToken] = useState();
    const [surchargeErrors, setSurchargeErrors] = useState(
        [],
        //     [
        //     { field: "amount", message: "amount is not available" },
        //     { field: "merchid", message: "Invalid merchid" },
        //     { field: "postal", message: "postal is missing or empty" },
        //     { field: "token", message: "Bin info not found for token" },
        //     { field: "token", message: "Invalid Token" },
        //     { field: "token", message: "token is missing or empty" },
        // ]
    );
    const [status, setStatus] = useState(null);
    const [statusHeader, setStatusHeader] = useState(null);
    const [statusBody, setStatusBody] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [surchargeLoading, setSurchargeLoading] = useState(false);
    const [showSurcharge, setShowSurcharge] = useState(false);
    const [surchargeFee, setSurchargeFee] = useState(0);
    const [ccError, setCCError] = useState(null);
    const [achError, setACHError] = useState(null);
    const [otherError, setOtherError] = useState(null);
    const [iframeLoading, setIframeLoading] = useState(isExit ? false : true);
    const [pageError, setPageError] = useState(null);
    const [selectPM, setSelectedPM] = useState("card");
    const [achData, setACHData] = useState({
        accType: "",
        bankaba: 0,
        accountNumber: "",
        accountNumber2: "",
    });
    const [achVerifying, setACHVerifying] = useState(false);
    const [achToken, setACHToken] = useState(null);
    const accOptions = [
        {
            label: "Checking Account",
            value: "ECHK",
        },
        {
            label: "Savings Account",
            value: "ESAV",
        },
    ];

    const billingPostalRef = useRef("");

    const timerRef = useRef(null); // holds the 1s timer
    const iframeRef = useRef(null);

    const billingErrors = ["Billing Zip Code is required", "Invalid Billing Zip Code"];
    const gatewayTokenRegex = /^\d{16}$/;

    const paymentMethods = [
        { key: "card", icon: "/images/credit_card.svg", label: "Credit Card", type: "svg" },
        { key: "ach", icon: "/images/bank.svg", label: "ACH", type: "svg" },
        // { key: "applepay", icon: "/images/apple_pay.svg", label: "Apple Pay", type: "svg" },
        // { key: "googlepay", icon: "/images/g_pay.svg", label: "Google Pay", type: "svg" },
    ];

    const getStyle = (methodKey) => ({
        border: selectPM === methodKey ? "1px solid #4a453e" : "1px solid transparent",
        borderRadius: "20px",
        color: "#4a453e",
        padding: "0px 12px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    });
    const paymentStatusMap = {
        inProgress: {
            header: "Payment in Progress...",
            body: "Your payment is being processed. Please do not close this window.",
            icon: "pi pi-spinner pi-spin",
            color: "#f0ad4e",
        },
        success: {
            header: "Payment Successful!",
            body: "Thank you! Your payment has been processed successfully.",
            icon: "pi pi-check-circle",
            color: "green",
        },
        failed: {
            header: "Payment Failed!",
            body: "Unfortunately, your payment could not be processed. Please try again",
            icon: "pi pi-times-circle",
            color: "#eb1313b5",
        },
        error: {
            header: "Payment Error!",
            body: "Something went wrong! Please try again later.",
            icon: "pi pi-times-circle",
            color: "#eb1313b5",
        },
        pending: {
            header: "Payment Pending!",
            body: "Your payment is pending.",
            icon: "pi pi-clock",
            color: "gray",
        },
    };
    useEffect(() => {
        if ((!hasToken() || surchargeErrors.length > 0 || otherError) && showSurcharge) {
            setShowSurcharge(false);
        }
    }, [achToken, gatewayToken, surchargeErrors, otherError]);

    useEffect(() => {
        if (iframeLoading) {
            document.body.style.overflow = "hidden";
            document.body.style.height = "100vh";
        } else {
            document.body.style.overflow = "";
            document.body.style.height = "";
        }

        // Cleanup when component unmounts
        return () => {
            document.body.style.overflow = "";
            document.body.style.height = "";
        };
    }, [iframeLoading]);

    let jwtResponse;
    try {
        if (authToken) {
            jwtResponse = jwtDecode(authToken);
            // console.log("jwtResponse", jwtResponse);
        }
    } catch (err) {
        // console.error("Invalid JWT:", err);
    }
    useEffect(() => {
        if (iframeLoading) {
            document.body.style.overflow = "hidden";
            document.body.style.height = "100vh";
        } else {
            document.body.style.overflow = "";
            document.body.style.height = "";
        }

        // Cleanup when component unmounts
        return () => {
            document.body.style.overflow = "";
            document.body.style.height = "";
        };
    }, [iframeLoading]);

    useEffect(() => {
        fetchCustomerDetails();
    }, []);

    useEffect(() => {
        if (selectPM === "card") {
            window.addEventListener("message", handleMessage);
        }
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [cardPointeUrl]);
    const showError = (msg) => {
        if (!msg) {
            setCCError(msg);
            timerRef.current = null; // allow new messages
        }
        if (timerRef.current) return; // ignore if timer is active

        // Show the message
        setCCError(msg);

        // Start 1-second hold
        timerRef.current = setTimeout(() => {
            timerRef.current = null; // allow new messages
        }, 1000);
    };
    const hasToken = () => {
        if (selectPM === "card" && gatewayToken) {
            return true;
        }
        if (selectPM === "ach" && achToken) {
            return true;
        }
        return false;
    };
    const addFinalCardPointUrl = (finalUrl) => {
        setCardPointeUrl(finalUrl);
    };
    const validateBillingError = (code, onlyReturn = false) => {
        const limit = 5;
        let valid = code && code.length === limit;
        if (!onlyReturn) {
            setOtherError(valid ? null : !code ? billingErrors[0] : code.length !== limit ? billingErrors[1] : null);
        }
        return valid;
    };
    const handleMessage = (event) => {
        if (selectPM === "ach" || !cardPointeUrl) return;
        const allowedOrigin = new URL(cardPointeUrl).origin;
        if (event.origin !== allowedOrigin) {
            // console.warn("Ignored message from untrusted origin:", event.origin);
            if (ccError) showError(null);
            return;
        }

        try {
            const data = JSON.parse(event.data);
            if (data && data.message && gatewayTokenRegex.test(data.message)) {
                showError(null);
                setGatewayToken(data.message);
                const currentPostal = billingPostalRef.current;
                if (validateBillingError(currentPostal)) {
                    checkSurcharge(currentPostal, data.message);
                }
            } else {
                // console.log("Other message:", data);
                if (data.validationError) {
                    setGatewayToken(null);
                    showError(data.validationError);
                } else {
                    showError(null);
                }
            }
        } catch (err) {
            // console.log("Invalid JSON from iframe:", err);
            if (ccError) showError(null);
        }
    };
    const handleExit = () => {
        try {
            let currentUrl = window.location.href;
            window.location.href = `${currentUrl}&exit=true`;
        } catch (error) {
            console.error("Error exiting checkout page:", error);
        }
    };
    const handlePaymentMethodChange = (pm) => {
        if (pm === "card") {
            setCardPointeUrl(tradePartner.merchantUrl);
        } else {
            setACHError(null);
            setACHData({
                accType: "",
                bankaba: 0,
                accountNumber: "",
                accountNumber2: "",
            });
        }
        setSelectedPM(pm);
    };
    const fetchCustomerDetails = async () => {
        if (!customerId) {
            setPageError(`User not found`);
            setIframeLoading(false);
            return;
        }
        let cognitoId;
        try {
            cognitoId = "username" in jwtResponse ? jwtResponse["username"] : jwtResponse["sub"];
        } catch (e) {
            console.log(e);
            setPageError("Unauthorised User");
            setIframeLoading(false);
            return;
        }
        try {
            const payload = {
                filter: {
                    $and: [
                        { serviceTypeName: "Imagine Home", "user.cognitoId": cognitoId },
                        {
                            $or: [{ "user.disabledUser": { $exists: false } }, { "user.disabledUser": false }],
                        },
                    ],
                },
            };
            let user = await ImagineHomeService.fetchUserDetailsWithToken(payload, authToken);
            if (!user || user.length === 0) {
                setPageError("Unauthorised User");
                setIframeLoading(false);
                return;
            }

            const sId = user[0].serviceId;
            setServiceId(sId);
            const formData = new FormData();

            formData.append("serviceId", sId);
            formData.append("customerID", customerId);
            let data = await ImagineHomeService.fetchCustomerDesignerDetails(formData);

            if (data && data.message === "Ok") {
                // if (data.designer.email !== designerId) {
                //     setPageError("Designer Id mismatched");
                //     setIframeLoading(false);
                //     return;
                // }
                setCustomer(data.customer);
                setDesigner(data.designer);
                if (data.designer.org) {
                    fetchSingleTradePartnerData(sId, data.designer.org._id);
                } else {
                    setPageError("Merchant not found");
                    setIframeLoading(false);
                }
            } else {
                setPageError("Something went wrong!");
                setIframeLoading(false);
            }
        } catch (e) {
            console.log(e);
            setPageError("Something went wrong!");
            setIframeLoading(false);
        }
    };
    // const fetchCustomerDetails = async () => {
    //     let cognitoId;
    //     try {
    //         cognitoId = "username" in jwtResponse ? jwtResponse["username"] : jwtResponse["sub"];
    //     } catch (e) {
    //         console.log(e);
    //         setPageError("User not found");
    //         setIframeLoading(false);
    //         return;
    //     }
    //     try {
    //         const payload = {
    //             filter: {
    //                 $and: [
    //                     { serviceTypeName: "Imagine Home", "user.cognitoId": cognitoId },
    //                     {
    //                         $or: [{ "user.disabledUser": { $exists: false } }, { "user.disabledUser": false }],
    //                     },
    //                 ],
    //             },
    //         };
    //         let customerDetails = await ImagineHomeService.fetchUserDetails(payload);
    //         if (!customerDetails || customerDetails.length === 0) {
    //             setPageError("User not found");
    //             setIframeLoading(false);
    //             return;
    //         }

    //         if (customerDetails[0].user.role !== "ihcustomer") {
    //             setPageError("User not found");
    //             setIframeLoading(false);
    //             return;
    //         }

    //         setServiceId(customerDetails[0].serviceId);
    //         const formData = new FormData();

    //         formData.append("serviceId", customerDetails[0].serviceId);
    //         formData.append("customerID", customerDetails[0].user.email);
    //         let data = await ImagineHomeService.fetchCustomerDesignerDetails(formData);

    //         if (data && data.message === "Ok") {
    //             setCustomer(data.customer);
    //             setDesigner(data.designer);
    //             if (data.designer.org) {
    //                 fetchSingleTradePartnerData(customerDetails[0].serviceId, data.designer.org._id);
    //             } else {
    //                 setPageError("Merchant not found");
    //                 setIframeLoading(false);
    //             }
    //         } else {
    //             setPageError("Something went wrong!");
    //             setIframeLoading(false);
    //         }
    //     } catch (e) {
    //         console.log(e);
    //         setPageError("Something went wrong!");
    //         setIframeLoading(false);
    //     }
    // };
    const fetchSingleTradePartnerData = async (serviceId, orgId) => {
        try {
            const res = await ImagineHomeService.getSingleTradePartnerInformation({
                serviceId,
                orgId,
            });
            if (res.responseCode === 200) {
                if (!res.responseData.payEnabled) {
                    setPageError("This merchant is not approved to process payment transactions.");
                    setIframeLoading(false);
                } else if (!res.responseData.merchantUrl || !res.responseData.merchantId) {
                    setPageError("Missing merchant details");
                    setIframeLoading(false);
                } else {
                    setTradePartner(res.responseData);
                    const url = res.responseData.merchantUrl;
                    if (selectPM === "card") {
                        setCardPointeUrl(url);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching trade partner data:", error);
            setPageError("Something went wrong!");
            setIframeLoading(false);
        }
    };

    const sendMail = () => {
        let data = {
            SENDER: "support@nextqore.com",
            to: ["komal.khairnar@nextqore.com", "ashay.deshmukh@nextqore.com", "kunal.chavan@nextqore.com"],
            cc: [],
            bcc: [],
            subject: "Imagine Home: Order Creation Failed",
            body: `
                    <label>Order creation has been failed for customer ${customer.email}.</label><br>
                    <label>${proposalId ? "Proposal" : "Plan"} Id: ${proposalId ? proposalId : planId ? planId : "--"}</label><br>
                    <label>Designer: ${designer.email}</label><br><br>
                `,
        };
        commonMailSender(data);
    };
    const checkSurcharge = async (postal, token) => {
        setSurchargeErrors([]);
        setShowSurcharge(false);
        setSurchargeLoading(true);
        try {
            const payload = { serviceId: serviceId, merchantKey: tradePartner._id, amount: parseFloat(amount), postal: postal, token };
            const headers = {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            };

            const res = await CardPointeService.checkSurcharge(headers, payload);

            if (res.status === 200) {
                let resp = res.data;
                if (resp.data.fee_amount) {
                    setSurchargeFee(resp.data.fee_amount);
                    setShowSurcharge(true);
                } else if (resp.data.messages && resp.data.messages.length) {
                    setSurchargeErrors(resp.data.messages);
                }
            }
        } catch (error) {
            console.error("Error checking surcharge fee:", error);
        } finally {
            setSurchargeLoading(false);
        }
    };
    const handlePay = async () => {
        if (selectPM === "card") {
            makePayment(gatewayToken);
        } else if (selectPM === "ach") {
            verifyACH(achToken);
        }
    };
    const verifyACH = async () => {
        if (!validateBillingError(billingPostalRef.current)) return;
        setACHVerifying(true);
        try {
            const payload = { serviceId: serviceId, merchantKey: tradePartner._id, routingNumber: achData.bankaba, accountNumber: achData.accountNumber };
            const headers = {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            };

            const res = await CardPointeService.getACHToken(headers, payload);

            if (res.status === 200) {
                let resp = res.data;
                if (resp.data.token) {
                    setACHToken(resp.data.token);
                    makePayment(resp.data.token);
                } else {
                    setACHError(resp.data.message || "Error while verifying the account details");
                }
            }
        } catch (error) {
            console.error("Error getting ACH token:", error);
            setACHError(error.message || "Error while verifying the account details");
        } finally {
            setACHVerifying(false);
        }
    };
    const validateACHFields = () => {
        if (achData.accType && achData.bankaba && achData.accountNumber && achData.accountNumber2) {
            let error = isRoutingNoValid() || isAccountNo1Valid() || isAccountNo2Valid();
            return error;
        } else {
            return "Please fill all the details.";
        }
    };
    const isAccountTypeValid = () => {
        if (!achData.accType) {
            return "Please select the Account Type";
        }
        return null;
    };
    const revertACHToken = () => {
        if (achToken) {
            setACHToken(null);
        }
    };
    const isRoutingNoValid = (val) => {
        let value = val || achData.bankaba;
        if (!value) {
            return "Routing number is mandatory.";
        }
        if (value.length !== 9) {
            return "Routing number should be 9 digits.";
        }
        return null;
    };
    const isAccountNo1Valid = (val) => {
        let value = val || achData.accountNumber;

        if (!value) {
            return "Account number is mandatory.";
        }
        if (value.length < 8 || value.length > 17) {
            return "Account number should be between 8 to 17 digits.";
        }
        if (achData.accountNumber2 && value !== achData.accountNumber2) {
            return "Account number does not match.";
        }
        return null;
    };
    const isAccountNo2Valid = (val) => {
        let value = val || achData.accountNumber2;
        if (!value) {
            return "Please re-enter the Account Number";
        }
        if (achData.accountNumber && achData.accountNumber !== value) {
            return "Account number does not match.";
        }
        return null;
    };

    const makePayment = async (token) => {
        try {
            setPaymentStatus("inProgress");
            setShowDialog(true);
            const payload = {
                serviceId,
                token,
                merchantKey: tradePartner._id,
                amount: parseFloat(amount),
                surcharge_fee: parseFloat(surchargeFee),
                paymentMethod: selectPM,
                paymentGateway: "cardPointe",
                payee: {
                    customer: customer.userId,
                    customerCognitoId: customer.cognitoId,
                    customerName: customer.name,
                    customerID: customer.email,
                    customerPhone: customer.mobile,
                    orgId: tradePartner._id,
                    designer: designer.userId,
                    designerID: designer.email,
                    designerCognitoId: designer.cognitoId,
                    postal: billingPostalRef.current,
                    name: customer.name,
                    email: customer.email,
                    phone: customer.mobile,
                },
            };
            if (proposalId) {
                payload.payee.docType = "quote";
                payload.payee.docID = proposalId;
            }
            if (planId) {
                payload.payee.docType = "plan";
                payload.payee.docID = planId;
            }
            if (selectPM === "ach") {
                payload.bankaba = achData.bankaba;
                payload.accType = achData.accType;
                payload.achDescription = proposalId ? proposalId : planId ? planId : "--";
            }
            const headers = {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            };

            const paymentRes = await CardPointeService.createPayment(headers, payload);
            if (paymentRes) {
                // console.log(`Payment response: ${JSON.stringify(paymentRes)}`);

                if (paymentRes.status === 200) {
                    const data = paymentRes.data;
                    const stat = data.status;
                    if (stat.toLowerCase() === "success") {
                        if (proposalId) {
                            try {
                                let formData = new FormData();
                                formData.append("serviceId", serviceId);
                                formData.append("customerID", customer.email);
                                formData.append("designerID", designer.email);
                                formData.append("docType", "quote");
                                formData.append("docID", proposalId);
                                formData.append("orderID", data.orderId);
                                formData.append("orderTransactionID", data.transactionId);
                                formData.append("orderAmt", amount);
                                formData.append("orderStatus", "Success");
                                formData.append("remark", "Success");

                                let order_res = await ImagineHomeService.createOrder(formData);
                                if (order_res && order_res.status !== 200) {
                                    //send email to us
                                    sendMail();
                                }
                                setPaymentStatus("success");
                            } catch (e) {
                                //send email to us
                                sendMail();
                                setPaymentStatus("success");
                            }
                        } else {
                            setPaymentStatus("success");
                        }
                    } else {
                        setPaymentStatus("failed");
                    }
                } else {
                    setStatusHeader("Payment Failed!");
                    setStatusBody(paymentRes.data.error && paymentRes.data.message ? paymentRes.data.message : "Something went wrong! Please try again later.");
                }
            } else {
                setPaymentStatus("error");
            }
        } catch (err) {
            console.log("Error ", err.response?.data?.error?.message || err?.message);
            setPaymentStatus("error");
        }
    };
    const getTotalAmount = () => {
        let surch = surchargeFee ? parseFloat(surchargeFee) : 0;
        let totalAm = parseFloat(amount);
        let total = totalAm + surch;
        return total;
    };
    const isDisabled = () => {
        const invalid = (selectPM === "card" && (!gatewayToken || !validateBillingError(billingPostalRef.current, true) || surchargeErrors.length > 0 || surchargeLoading)) || (selectPM === "ach" && (validateACHFields() || !validateBillingError(billingPostalRef.current, true))) || achVerifying;
        return invalid ? true : false;
    };
    const setPaymentStatus = (statusKey) => {
        const status = paymentStatusMap[statusKey];
        if (!status) return;
        setStatus(statusKey);
        setStatusHeader(status.header);
        setStatusBody(status.body);
    };
    const LabeledInput = ({ id, label, value, classVal = "col-6 p-1", onChange, inputType }) => (
        <div className={classVal}>
            <label htmlFor={id} className="block editFeatureLabelPayment mb-2 text-sm">
                {label}
            </label>
            <InputText id={id} className="w-full addFeatureInput text-sm" onChange={onChange} type={inputType} value={value} disabled={onChange ? false : true} />
        </div>
    );
    const LabelText = ({ value }) => (
        <div className="col-12 p-0">
            <label className="inline-block featureHeading my-3 text-2xl">{value}</label>
        </div>
    );
    const paymentStatusFooter = (
        <div className="col:6 flex gap-3 justify-content-center">
            {status !== "inProgress" && (
                <div className="col-5">
                    <Button
                        label="OK"
                        onClick={() => {
                            handleExit();
                        }}
                        className=" p-button-rounded font-Gerstner-ProgramRegular w-full"
                        style={{
                            letterSpacing: "1.44px",
                            backgroundColor: "#47422F",
                            borderColor: "#47422F",
                        }}
                    />
                </div>
            )}
        </div>
    );

    const StatusIcon = ({ val }) => {
        const { icon, color } = paymentStatusMap[val ?? status] || {
            icon: "pi pi-question-circle",
            color: "black",
        };

        return <i className={`${icon} mb-3`} style={{ fontSize: "2rem", color }} />;
    };
    return authToken && amount ? (
        <div className="relative p-0 m-0" style={{ background: "#FBF9F3", width: "100%", height: "100%" }}>
            {(iframeLoading || pageError) && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#FBF9F3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 50,
                        overflow: "hidden",
                    }}
                >
                    {iframeLoading ? (
                        <svg className="splash-loader" width="8%" height="8%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle className="splash-path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    ) : (
                        <div className="flex flex-column align-items-center justify-content-center font-Gerstner-ProgramRegular p-5 sm:p-0 w-full sm:w-6">
                            <i className="pi pi-exclamation-triangle mb-2  self-center pi-large" style={{ fontSize: "3rem", color: "red" }} />
                            <p className="m-0 text-xl leading-none">{pageError}</p>
                        </div>
                    )}
                </div>
            )}
            <div className="p-4">
                <div className="flex justify-content-start w-full mb-2">
                    <img src={process.env.PUBLIC_URL + "/assets/layout/images/small_logo.svg"} alt=""></img>
                </div>
                {/* Client Info */}
                <LabelText value="Client Information"></LabelText>
                <div className="grid">
                    <LabeledInput id="name" label="Name" value={customer?.name} full />
                    <LabeledInput id="email" label="Email" value={customer?.email} />
                </div>
                <div className="grid mt-2">
                    <LabeledInput id="phone" label="Phone" classVal="col-12 sm:col-6 p-1" value={customer?.mobile} />
                </div>
                {/* Payment Info */}
                <LabelText value="Payment Information"></LabelText>
                <div className="grid">
                    <LabeledInput classVal="col-12 sm:col-6 p-1" id="mname" label="Pay To" value={tradePartner?.name} />
                    <LabeledInput classVal="col-12 sm:col-6 p-1" id={proposalId ? "proposal" : planId ? "plan" : ""} label={proposalId ? "Proposal No." : planId ? "Plan" : "Proposal No."} value={proposalId ? proposalId : planId ? planId : ""} />
                </div>
                <div className="grid mt-2">
                    <LabeledInput id="amount" label="Amount" value={`$ ${amount}`} />
                    <div className="col-6 p-1">
                        <label htmlFor="billingcode" className="block editFeatureLabelPayment mb-2 text-sm">
                            Billing Zip Code
                        </label>
                        <InputText
                            id="billingcode"
                            disabled={isExit}
                            className="w-full addFeatureInput text-sm"
                            onChange={(e) => {
                                setSurchargeErrors([]);
                                const value = e.target.value;
                                billingPostalRef.current = value; // ✅ always keep ref in sync
                                if (validateBillingError(value)) {
                                    if (selectPM === "card" && gatewayToken) {
                                        checkSurcharge(value, gatewayToken);
                                    }
                                }
                            }}
                            type="number"
                        />
                    </div>
                </div>

                {!isExit && (
                    <div className="col-12 md:col-6 p-1">
                        <label htmlFor="paymentMethod" className="block editFeatureLabelPayment mb-3 text-sm">
                            Payment Method
                        </label>
                        <div className="flex flex-row align-items-center justify-content-center md:justify-content-start gap-4 flex-wrap">
                            {paymentMethods.map((method) => (
                                <div key={method.key} onClick={() => handlePaymentMethodChange(method.key)} style={getStyle(method.key)}>
                                    <img src={method.icon} alt={method.label} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Iframe */}
                {/* {!isExit && selectPM === "card" && customer && designer && tradePartner && cardPointeUrl && <CardPointeTokenizerIframe iframeRef={iframeRef} setIframeLoading={setIframeLoading} srcUrl={cardPointeUrl} addFinalCardPointUrl={addFinalCardPointUrl} />} */}
                {!isExit && customer && designer && tradePartner && cardPointeUrl && (
                    <div style={{ display: selectPM === "card" ? "block" : "none" }}>
                        <CardPointeTokenizerIframe iframeRef={iframeRef} setIframeLoading={setIframeLoading} srcUrl={cardPointeUrl} addFinalCardPointUrl={addFinalCardPointUrl} />
                    </div>
                )}
                {!isExit && selectPM === "ach" && (
                    <div className="grid mt-2">
                        <div className="col-6 p-1">
                            <label htmlFor="accType" className="block editFeatureLabelPayment mb-2 text-sm">
                                Account Type
                            </label>
                            <Dropdown
                                className="w-full addFeatureInput text-sm"
                                value={achData.accType}
                                options={accOptions}
                                onChange={(e) => {
                                    revertACHToken();
                                    setACHData((prev) => ({ ...prev, accType: e.value }));
                                }}
                            />
                        </div>
                        <div className="col-6 p-1">
                            <label htmlFor="routingNumber" className="block editFeatureLabelPayment mb-2 text-sm">
                                Routing Number
                            </label>
                            <InputText
                                id="routingNumber"
                                className="w-full addFeatureInput text-sm"
                                onChange={(e) => {
                                    revertACHToken();
                                    const val = e.target.value;
                                    setACHData((prev) => ({ ...prev, bankaba: val }));
                                    setACHError(isRoutingNoValid(val));
                                }}
                                type="number"
                            />
                        </div>
                        <div className="col-6 p-1">
                            <label htmlFor="accNumber" className="block editFeatureLabelPayment mb-2 text-sm">
                                Account Number
                            </label>
                            <InputText
                                id="accNumber"
                                className="w-full addFeatureInput text-sm"
                                onChange={(e) => {
                                    revertACHToken();
                                    const val = e.target.value;
                                    setACHData((prev) => ({ ...prev, accountNumber: val }));
                                    setACHError(isAccountNo1Valid(val));
                                }}
                                type="number"
                            />
                        </div>
                        <div className="col-6 p-1">
                            <label htmlFor="accNumber2" className="block editFeatureLabelPayment mb-2 text-sm">
                                Re-enter Account Number
                            </label>
                            <InputText
                                id="accNumber2"
                                className="w-full addFeatureInput text-sm"
                                type="number"
                                onChange={(e) => {
                                    revertACHToken();
                                    const val = e.target.value;
                                    setACHData((prev) => ({ ...prev, accountNumber2: val }));
                                    setACHError(isAccountNo2Valid(val));
                                }}
                            />
                        </div>
                    </div>
                )}
                {selectPM === "card" && ccError && (
                    <div className="flex align-items-center font-Gerstner-ProgramRegular p-0 mt-3">
                        <i className="pi pi-exclamation-triangle mr-2" style={{ fontSize: "1.5rem", color: "red" }} />
                        <p className="m-0 text-lg leading-none">{ccError}</p>
                    </div>
                )}
                {otherError && (
                    <div className="flex align-items-center font-Gerstner-ProgramRegular p-0 mt-3">
                        <i className="pi pi-exclamation-triangle mr-2" style={{ fontSize: "1.5rem", color: "red" }} />
                        <p className="m-0 text-lg leading-none">{otherError}</p>
                    </div>
                )}
                {selectPM === "ach" && achError && (
                    <div className="flex align-items-center font-Gerstner-ProgramRegular p-0 mt-3">
                        <i className="pi pi-exclamation-triangle mr-2" style={{ fontSize: "1.5rem", color: "red" }} />
                        <p className="m-0 text-lg leading-none">{achError}</p>
                    </div>
                )}
                {selectPM === "card" &&
                    surchargeErrors.length > 0 &&
                    surchargeErrors.map((err, index) => (
                        <div key={index} className="flex align-items-center font-Gerstner-ProgramRegular p-0 mt-3">
                            <i className="pi pi-exclamation-triangle mr-2" style={{ fontSize: "1.5rem", color: "red" }} />
                            <p className="m-0 text-lg leading-none">{err.message}</p>
                        </div>
                    ))}
                {showSurcharge && (
                    <div>
                        <label className="block editFeatureLabelPayment text-sm">Surcharge fee is applicable on this credit card.</label>
                        <label className="block editFeatureLabelPayment text-sm mt-1">
                            Surcharge Fee: <strong>${surchargeFee}</strong>
                        </label>
                    </div>
                )}
                {!isExit && (
                    <div className="grid mt-3">
                        <div className="col-12 md:col-8 lg:col-6 xl:col-6 mx-auto">
                            <Button
                                label={`${selectPM === "ach" ? "Verify & " : ""}Pay $${getTotalAmount()}`}
                                onClick={handlePay}
                                disabled={isDisabled()}
                                className="text-xl p-button-rounded font-Gerstner-ProgramRegular w-full"
                                style={{
                                    letterSpacing: "1.44px",
                                    backgroundColor: "#47422F",
                                    borderColor: "#47422F",
                                }}
                            />
                        </div>
                    </div>
                )}
                {showDialog && (
                    <Dialog
                        header={<h3 className="m-0 font-light font-larken">{statusHeader}</h3>}
                        style={{
                            width: "90vw",
                            maxWidth: "35rem",
                            color: "#1D1B1C",
                            fontFamily: "Gerstner-ProgramRegular",
                        }}
                        breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                        onHide={() => {
                            setShowDialog(false);
                        }}
                        visible={showDialog}
                        modal
                        closable={false}
                        draggable={false}
                        footer={paymentStatusFooter}
                    >
                        <div className="font-Gerstner-ProgramRegular p-0 mt-5 text-center">
                            <StatusIcon />
                            <p className="m-0 text-xl">{statusBody}</p>
                        </div>
                    </Dialog>
                )}
            </div>
        </div>
    ) : (
        <NotFound />
    );
}
